import { render } from "./DataPrinciples.vue?vue&type=template&id=6d5838dc&scoped=true"
import script from "./DataPrinciples.vue?vue&type=script&lang=js"
export * from "./DataPrinciples.vue?vue&type=script&lang=js"

import "./DataPrinciples.vue?vue&type=style&index=0&id=6d5838dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5838dc"]])

export default __exports__